import { accordionClasses, Components } from '@mui/material';

export function getMuiAccordion(): Components['MuiAccordion'] {
  return {
    styleOverrides: {
      root: {
        background: 'transparent',
        fontSize: 16,
        lineHeight: '17px',
        boxShadow: 'none',

        ':before': {
          display: 'none',
        },

        [`&.${accordionClasses.expanded}`]: {
          margin: 0,
        },
      },
    },
  };
}
